import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=8bdc6ea6&scoped=true"
import script from "./chatBox.vue?vue&type=script&lang=js"
export * from "./chatBox.vue?vue&type=script&lang=js"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=8bdc6ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc6ea6",
  null
  
)

export default component.exports